import { cohorts, reportBase } from './reportsBase';
import rules from './fieldVisibilityRules';
import { reportTypes } from '../../utils/reports';
import {
    decorateRetentionTableData,
    getRetentionCohortMetrics,
    RETENTION_CONVERSIONS_FIELD,
} from '../../utils/retentionReport';

export default {
    type: reportTypes.retention,
    fields: [...reportBase.fields, ...cohorts.fields],
    visibleRule: rules[reportTypes.retention],
    dataSelector: {
        ...reportBase.dataSelector,
        ...cohorts.dataSelector,
        tableDataFormatted: 'reportData',
    },
    // Retention always reports retained users against tracker conversions; neither is selectable.
    discrepancyMetrics: [RETENTION_CONVERSIONS_FIELD],
    // Read by the query builder (selector-side config, not the reducer one); heatmap isn't compare-safe.
    disableCompare: true,
    getCohortMetrics: getRetentionCohortMetrics,
    transformTableData: decorateRetentionTableData,
};
